import React from "react";

import { CarregandoBloco, CarregandoCards, CarregandoGrade, CarregandoLista, CarregandoTabela } from "@/components/carregando";

// Carregamento com cards (25/10/2026): na PRIMEIRA abertura de cada seção, o
// formato do que vem, piscando, no lugar do círculo girando. Cada esqueleto
// imita o layout real da seção (mesmas grades e alturas aproximadas).

export function EsqueletoVisaoGeral() {
  return (
    <div className="space-y-6" data-e2e="esqueleto-visao-geral">
      <CarregandoCards quantos={4} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" altura="h-[156px]" />
      <CarregandoBloco altura="h-[440px]" />
      <CarregandoBloco altura="h-[470px]" />
    </div>
  );
}

export function EsqueletoProdutos() {
  return (
    <div className="space-y-6" data-e2e="esqueleto-produtos">
      <CarregandoCards quantos={3} className="grid grid-cols-1 sm:grid-cols-3 gap-3" altura="h-[156px]" />
      <CarregandoLista linhas={6} colunas={2} />
      <CarregandoTabela linhas={6} colunas={6} />
    </div>
  );
}

export function EsqueletoModulos() {
  return (
    <div className="space-y-6" data-e2e="esqueleto-modulos">
      <CarregandoBloco altura="h-[240px]" />
      <CarregandoGrade quantos={4} className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" altura="h-[380px]" />
    </div>
  );
}

export function EsqueletoPagamentos() {
  return (
    <div className="space-y-6" data-e2e="esqueleto-pagamentos">
      <CarregandoCards quantos={3} className="grid grid-cols-1 md:grid-cols-3 gap-4" altura="h-[96px]" />
      <CarregandoBloco altura="h-[400px]" />
    </div>
  );
}

export function EsqueletoClientes() {
  return (
    <div className="space-y-6" data-e2e="esqueleto-clientes">
      <CarregandoCards quantos={4} className="grid grid-cols-2 lg:grid-cols-4 gap-4" altura="h-[96px]" />
      <CarregandoTabela linhas={8} colunas={7} />
    </div>
  );
}

// Trocar o período depois da primeira carga: o conteúdo fica, só esmaece até a
// resposta chegar (sem piscar a tela inteira).
export function Esmaecer({ ativo, children }) {
  return (
    <div className={`space-y-6 transition-opacity duration-200 ${ativo ? "opacity-50 pointer-events-none" : ""}`} aria-busy={ativo || undefined}>
      {children}
    </div>
  );
}
